/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function bSGetCustomerByEmailQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bSGetCustomerByEmailInput(emailId: string): IDataServiceRequest {
    const query = bSGetCustomerByEmailQuery();
    return query.createDataServiceRequestForOperation(
        'BSGetCustomerByEmail',
        true,
        DataServiceEntities.CommerceCustomerExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICommerceCustomer' },
        {
            EmailId: emailId
        }
    );
}

export function bSGetCustomerByEmailAsync(context: IContext, emailId: string): AsyncResult<DataServiceEntities.ICommerceCustomer> {
    const request = bSGetCustomerByEmailInput(emailId);
    return callActionOrExecute<DataServiceEntities.ICommerceCustomer>(request, context.callerContext);
}

function bSGetCustomerByEmailAnonymousQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bSGetCustomerByEmailAnonymousInput(emailId: string): IDataServiceRequest {
    const query = bSGetCustomerByEmailAnonymousQuery();
    return query.createDataServiceRequestForOperation(
        'BSGetCustomerByEmailAnonymous',
        true,
        DataServiceEntities.CommerceCustomerExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICommerceCustomer' },
        {
            emailId: emailId
        }
    );
}

export function bSGetCustomerByEmailAnonymousAsync(context: IContext, emailId: string): AsyncResult<DataServiceEntities.ICommerceCustomer> {
    const request = bSGetCustomerByEmailAnonymousInput(emailId);
    return callActionOrExecute<DataServiceEntities.ICommerceCustomer>(request, context.callerContext);
}

function bSGetGiftCardBalanceQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bSGetGiftCardBalanceInput(cardNumber: string, currency: string): IDataServiceRequest {
    const query = bSGetGiftCardBalanceQuery();
    return query.createDataServiceRequestForOperation(
        'BSGetGiftCardBalance',
        true,
        DataServiceEntities.CardInfoExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICardInfo' },
        {
            cardNumber: cardNumber,
            currency: currency
        }
    );
}

export function bSGetGiftCardBalanceAsync(
    context: IContext,
    cardNumber: string,
    currency: string
): AsyncResult<DataServiceEntities.ICardInfo> {
    const request = bSGetGiftCardBalanceInput(cardNumber, currency);
    return callActionOrExecute<DataServiceEntities.ICardInfo>(request, context.callerContext);
}

function bSCaptureGiftCardPaymentQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bSCaptureGiftCardPaymentInput(cardNumber: string, approvedAmount: number, currency: string): IDataServiceRequest {
    const query = bSCaptureGiftCardPaymentQuery();
    return query.createDataServiceRequestForOperation(
        'BSCaptureGiftCardPayment',
        true,
        DataServiceEntities.CardInfoExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICardInfo' },
        {
            cardNumber: cardNumber,
            approvedAmount: approvedAmount,
            currency: currency
        }
    );
}

export function bSCaptureGiftCardPaymentAsync(
    context: IContext,
    cardNumber: string,
    approvedAmount: number,
    currency: string
): AsyncResult<DataServiceEntities.ICardInfo> {
    const request = bSCaptureGiftCardPaymentInput(cardNumber, approvedAmount, currency);
    return callActionOrExecute<DataServiceEntities.ICardInfo>(request, context.callerContext);
}

function bSDeleteB2BUserQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bSDeleteB2BUserInput(userID: string): IDataServiceRequest {
    const query = bSDeleteB2BUserQuery();
    return query.createDataServiceRequestForOperation(
        'BSDeleteB2BUser',
        true,
        DataServiceEntities.ECommerceDeleteB2BUserExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IECommerceDeleteB2BUser' },
        {
            userID: userID
        }
    );
}

export function bSDeleteB2BUserAsync(context: IContext, userID: string): AsyncResult<DataServiceEntities.IECommerceDeleteB2BUser> {
    const request = bSDeleteB2BUserInput(userID);
    return callActionOrExecute<DataServiceEntities.IECommerceDeleteB2BUser>(request, context.callerContext);
}

function bSGetTenderTypeQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bSGetTenderTypeInput(): IDataServiceRequest {
    const query = bSGetTenderTypeQuery();
    return query.createDataServiceRequestForOperation(
        'BSGetTenderType',
        true,
        String,
        'false',
        { bypassCache: 'get', returnEntity: 'string' },
        {}
    );
}

export function bSGetTenderTypeAsync(context: IContext): AsyncResult<string> {
    const request = bSGetTenderTypeInput();
    return callActionOrExecute<string>(request, context.callerContext);
}

function bSGetBalanceQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bSGetBalanceInput(cardNumber: string, currency: string, merchantId: string): IDataServiceRequest {
    const query = bSGetBalanceQuery();
    return query.createDataServiceRequestForOperation(
        'BSGetBalance',
        true,
        DataServiceEntities.CardInfoExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICardInfo' },
        {
            cardNumber: cardNumber,
            currency: currency,
            merchantId: merchantId
        }
    );
}

export function bSGetBalanceAsync(
    context: IContext,
    cardNumber: string,
    currency: string,
    merchantId: string
): AsyncResult<DataServiceEntities.ICardInfo> {
    const request = bSGetBalanceInput(cardNumber, currency, merchantId);
    return callActionOrExecute<DataServiceEntities.ICardInfo>(request, context.callerContext);
}

function bSRollBackGiftCardPaymentQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bSRollBackGiftCardPaymentInput(cardNumber: string, amount: number, currency: string): IDataServiceRequest {
    const query = bSRollBackGiftCardPaymentQuery();
    return query.createDataServiceRequestForOperation(
        'BSRollBackGiftCardPayment',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            cardNumber: cardNumber,
            amount: amount,
            currency: currency
        }
    );
}

export function bSRollBackGiftCardPaymentAsync(
    context: IContext,
    cardNumber: string,
    amount: number,
    currency: string
): AsyncResult<number> {
    const request = bSRollBackGiftCardPaymentInput(cardNumber, amount, currency);
    return callActionOrExecute<number>(request, context.callerContext);
}

function bSSaveCustomerProductInterestQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bSSaveCustomerProductInterestInput(
    customerId: string,
    customerEmailAddress: string,
    displayProductNumber: string,
    quantity: string,
    emailSent: boolean,
    productId: number,
    productURL: string,
    productImageURL: string,
    currency: string
): IDataServiceRequest {
    const query = bSSaveCustomerProductInterestQuery();
    return query.createDataServiceRequestForOperation(
        'BSSaveCustomerProductInterest',
        true,
        DataServiceEntities.EcommerceCustProductInterestExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICustomerProductInterest' },
        {
            customerId: customerId,
            customerEmailAddress: customerEmailAddress,
            displayProductNumber: displayProductNumber,
            quantity: quantity,
            emailSent: emailSent,
            productId: productId,
            productURL: productURL,
            productImageURL: productImageURL,
            currency: currency
        }
    );
}

export function bSSaveCustomerProductInterestAsync(
    context: IContext,
    customerId: string,
    customerEmailAddress: string,
    displayProductNumber: string,
    quantity: string,
    emailSent: boolean,
    productId: number,
    productURL: string,
    productImageURL: string,
    currency: string
): AsyncResult<DataServiceEntities.IEcommerceCustProductInterest> {
    const request = bSSaveCustomerProductInterestInput(
        customerId,
        customerEmailAddress,
        displayProductNumber,
        quantity,
        emailSent,
        productId,
        productURL,
        productImageURL,
        currency
    );
    return callActionOrExecute<DataServiceEntities.IEcommerceCustProductInterest>(request, context.callerContext);
}

function bSIssueCustomerLoyaltyCardQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bSIssueCustomerLoyaltyCardInput(loyaltyCard: Entities.LoyaltyCard): IDataServiceRequest {
    const query = bSIssueCustomerLoyaltyCardQuery();
    return query.createDataServiceRequestForOperation(
        'BSIssueCustomerLoyaltyCard',
        true,
        EntityClasses.LoyaltyCardClass,
        'false',
        { bypassCache: 'get', returnEntity: 'EntityClasses.LoyaltyCardClass' },
        {
            loyaltyCard: loyaltyCard
        }
    );
}

export function bSIssueCustomerLoyaltyCardAsync(context: IContext, loyaltyCard: Entities.LoyaltyCard): AsyncResult<Entities.LoyaltyCard> {
    const request = bSIssueCustomerLoyaltyCardInput(loyaltyCard);
    return callActionOrExecute<Entities.LoyaltyCard>(request, context.callerContext);
}

function bSGetCustomerCouponsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bSGetCustomerCouponsInput(queryResultSettings: IQueryResultSettings, key: string): IDataServiceRequest {
    const query = bSGetCustomerCouponsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'BSGetCustomerCoupons',
        true,
        EntityClasses.CouponClass,
        'true',
        { bypassCache: 'get', returnEntity: 'EntityClasses.CouponClas' },
        {
            key: key
        }
    );
}

export function bSGetCustomerCouponsAsync(context: IContext, key: string): AsyncResult<Entities.Coupon[]> {
    const request = bSGetCustomerCouponsInput(context.queryResultSettings || {}, key);
    return callActionOrExecute<Entities.Coupon[]>(request, context.callerContext);
}

function bSAddRemoveCustomerCouponQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bSAddRemoveCustomerCouponInput(key: string, coupons: Entities.Coupon[]): IDataServiceRequest {
    const query = bSAddRemoveCustomerCouponQuery();
    return query.createDataServiceRequestForOperation(
        'BSAddRemoveCustomerCoupon',
        true,
        EntityClasses.CartClass,
        'false',
        { bypassCache: 'get', returnEntity: 'EntityClasses.CartClass' },
        {
            key: key,
            coupons: coupons
        }
    );
}
function bSGetCollectionPointsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bSAddRemoveCustomerCouponAsync(context: IContext, key: string, coupons: Entities.Coupon[]): AsyncResult<Entities.Cart> {
    const request = bSAddRemoveCustomerCouponInput(key, coupons);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
}

export function bSGetCollectionPointsInput(parameters: DataServiceEntities.IGetCollectionPointsRequest): IDataServiceRequest {
    const query = bSGetCollectionPointsQuery();
    return query.createDataServiceRequestForOperation(
        'BSGetCollectionPoints',
        true,
        DataServiceEntities.CollectionPointsExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICollectionPoints' },
        {
            parameters: parameters
        }
    );
}

export function bSGetCollectionPointsAsync(
    context: IContext,
    parameters: DataServiceEntities.IGetCollectionPointsRequest
): AsyncResult<DataServiceEntities.ICollectionPoints> {
    const request = bSGetCollectionPointsInput(parameters);
    return callActionOrExecute<DataServiceEntities.ICollectionPoints>(request, context.callerContext);
}

function bsGetCategoryDataQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bsGetCategoryDataInput(categoryId: number, includeSeoData: boolean): IDataServiceRequest {
    const query = bsGetCategoryDataQuery();
    return query.createDataServiceRequestForOperation(
        'BSGetCategoryData',
        true,
        DataServiceEntities.CategoryExtExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICategoryExt' },
        {
            categoryId: categoryId,
            includeSeoData: includeSeoData
        }
    );
}

export function bsGetCategoryDataAsync(
    context: IContext,
    categoryId: number,
    includeSeoData: boolean
): AsyncResult<DataServiceEntities.ICategoryExt> {
    const request = bsGetCategoryDataInput(categoryId, includeSeoData);
    return callActionOrExecute<DataServiceEntities.ICategoryExt>(request, context.callerContext);
}
